/**
 * CWR 2.4 — event "When" + capacity block (mockup .ev2): serif date headline,
 * duration · modality · price meta, and a slim capacity bar.
 */
import type { HubServiceDto } from '@/api/types';
import { modalityLabel } from '@/pages/BookSessionPage/catalogFormat';
import { modalityIcon } from '@/pages/BookSessionPage/catalogIcons';
import { ClockMetaIcon } from '../detailIcons';
import { formatDuration } from '../detailFormat';
import styles from '../SessionDetailPage.module.css';

export interface EventWhenBlockProps {
  whenText: string;
  duration: number;
  modality: HubServiceDto['modality'];
  priceText: string;
  spotsRemaining: number;
  capacity: number;
}

export function EventWhenBlock({
  whenText,
  duration,
  modality,
  priceText,
  spotsRemaining,
  capacity,
}: EventWhenBlockProps) {
  const booked = Math.max(0, capacity - spotsRemaining);
  const pct = capacity > 0 ? Math.min(100, Math.round((booked / capacity) * 100)) : 0;
  return (
    <div className={styles.ev} data-testid="event-when">
      <div className={styles.evWhen}>{whenText}</div>
      <div className={styles.evMeta}>
        <span className={styles.m}>
          {ClockMetaIcon}
          {formatDuration(duration)}
        </span>
        <span className={styles.sep} />
        <span className={styles.m}>
          {modalityIcon(modality)}
          {modalityLabel(modality)}
        </span>
        <span className={styles.pr}>{priceText}</span>
      </div>
      {capacity > 0 && (
        <div className={styles.cap}>
          <div className={styles.capRow}>
            <span className={styles.capLabel}>
              {booked} of {capacity} booked
            </span>
            {spotsRemaining > 0 && (
              <span className={styles.spots}>
                {spotsRemaining} {spotsRemaining === 1 ? 'spot' : 'spots'} left
              </span>
            )}
          </div>
          <div className={styles.capbar}>
            <span style={{ width: `${pct}%` }} />
          </div>
        </div>
      )}
    </div>
  );
}
